import React from 'react';
import { useListArticlesQuery } from '../../redux/api/articleApi';

const ArticleSelector = ({
  articlesToBook,
  setArticlesToBook,
  crew = true,
  bar = true,
}) => {
  const { data: articles } = useListArticlesQuery();

  const addArticle = ({ article }) => {
    if (articlesToBook.some((art) => art.article.id === article.id)) {
      return;
    }
    setArticlesToBook([...articlesToBook, { article: article, quantity: 0 }]);
  };

  const handleArticleSelect = (event) => {
    const selectedArticleId = event.target.value;
    if (selectedArticleId) {
      const selectedArticle = articles.find(
        (article) => article.id === selectedArticleId
      );
      if (selectedArticle) {
        addArticle({ article: selectedArticle });
      }
    }
  };

  return articles ? (
    <select id='article' className='form-select' onChange={handleArticleSelect}>
      <option key={0} value=''>
        Artikel auswählen
      </option>
      {articles?.map((article, index) => (
        <option key={index} value={article.id}>
          {article.name}
        </option>
      ))}
    </select>
  ) : null;
};

export default ArticleSelector;
